
import {format} from 'date-fns/esm'
import {debounce} from 'lodash-es'

// サーバーへポストする

import axios from 'axios'
import StackTrace from 'stacktrace-js'

function postToServer(cause, args) {

  // 開発サーバーではsourcemapの解決ができず正確なスタックが取得できないため、送らない
  if(process.env.NODE_ENV === 'development') {
    return
  }

  const time = format(Date.now(), 'yyyy-MM-dd HH:mm:ss')
  Promise.all(args.map(async arg => {
    if(arg instanceof Error) {
      try {
        return {
          string: arg.toString(),
          trace: await StackTrace.fromError(arg),
        }
      }
      catch(e) {}
    }
    return arg
  }))
  .then(args => {
    axios.post('/api/error-report', {time, url: window.location.href, cause, args})
    .catch(() => {})
  })
}

// Quasarのポップアップを表示する

import {Notify} from 'quasar'

const popupDo = debounce(function(options) {
  Notify.create({
    ...options,
    position: 'top-left',
    timeout: 0,
    actions: [{icon: 'close'}],
  })
}, 500)

function popup(options) {
  if(process.env.NODE_ENV === 'development') {
    popupDo(options)
  }
}

// vuexストア上のdebug_report_jsがtrueになったらレポートを有効にする

import Vue from 'vue'
import store from 'store'

let firstRun = true
store.watch(state => state.config.debug_report_js, value => {
  if(!value || !firstRun) {
    return
  }
  firstRun = false
  console.log('error-reporter activated.') // eslint-disable-line no-console

  // error/warning出力
  // VMが直接発するconsoleログはインターセプトできない

  const original_console_error = window.console.error
  window.console.error = function(...args) {
    original_console_error(...args)
    postToServer('console.error', args)
    popup({message: 'Javascript Error', type: 'negative'})
  }

  const original_console_warn = window.console.warn
  window.console.warn = function(...args) {
    original_console_warn(...args)
    postToServer('console.warn', args)
    popup({message: 'Javascript Warning', type: 'warning'})
  }

  // Vueのerror/warningハンドラ

  Vue.config.errorHandler = function(err, vm, info) { // eslint-disable-line no-unused-vars
    console.error(err) // eslint-disable-line no-console
  }

  Vue.config.warnHandler = function(msg, vm, trace) { // eslint-disable-line no-unused-vars
    console.warn(msg) // eslint-disable-line no-console
  }

  // window.onerrorのインターセプト

  const original_onerror = window.onerror
  window.onerror = function(msg, file, line, col, err) {
    if(original_onerror != null) {
      original_onerror(msg, file, line, col, err)
    }
    postToServer('window.onerror', [msg, file, line, col, err])
  }

  // unhandledrejection/unhandledrejectionイベントのリスナ
  // chrome以外では動作しない、webpack-dev-server経由の場合は動作しない

  window.addEventListener('unhandledrejection', function(e) {
    postToServer('unhandledrejection', [e.reason])
  })

  window.addEventListener('rejectionhandled', function(e) {
    postToServer('rejectionhandled', [e])
  })
})
